import { useState, useCallback } from 'react';
import { message } from 'antd';
import { settlementService } from '../../../../api/enhancedApi';
import apInvoicePipelineApi from '../../services/apInvoicePipelineApi';

// 使用增强API服务
const api = {
  list: settlementService.listInvoiceDataSources,
  delete: settlementService.deleteInvoiceDataSource,
  batchDelete: settlementService.batchDeleteInvoiceDataSources,
  create: settlementService.createInvoiceDataSource,
  update: settlementService.updateInvoiceDataSource
};

export const useInvoiceDataSourceActions = () => {
  const [loading, setLoading] = useState(false);

  // 获取列表数据
  const fetchList = useCallback(async (params) => {
    setLoading(true);
    try {
      console.log("🚀 API调用参数:", params);
      const response = await api.list(params);
      console.log("🎯 API响应:", response);
      console.log("📋 响应数据结构:", {
        status: response.status,
        data: response.data,
        dataType: typeof response.data,
        hasItems: response.data?.items ? true : false,
        itemsLength: response.data?.items?.length,
        total: response.data?.total
      });
      return response.data;
    } catch (error) {
      console.error("❌ API调用失败:", error);
      message.error('获取数据失败: ' + (error.response?.data?.detail || error.message));
      throw error;
    } finally {
      setLoading(false);
    }
  }, []);

  // 删除单个记录
  const deleteRecord = useCallback(async (id) => {
    try {
      const response = await api.delete(id);
      if (response.data.success) {
        message.success(response.data.message || '删除成功');
        return true;
      } else {
        message.error(response.data.message || '删除失败');
        return false;
      }
    } catch (error) {
      message.error('删除失败: ' + (error.response?.data?.detail || error.message));
      return false;
    }
  }, []);

  // 批量删除记录
  const batchDeleteRecords = useCallback(async (ids) => {
    try {
      const response = await api.batchDelete(ids);
      const payload = response.data?.data || {};
      const success = response.data?.success === true;
      const successCount = payload.succeeded || 0;
      const totalCount = (payload.succeeded || 0) + (payload.failed || 0);
      
      if (success) {
        message.success(`批量删除成功，共删除 ${successCount} 条记录`);
      } else {
        message.warning(`部分删除成功，成功删除 ${successCount}/${totalCount} 条记录`);
      }
      return success;
    } catch (error) {
      message.error('批量删除失败: ' + (error.response?.data?.detail || error.message));
      return false;
    }
  }, []);

  // 重新解析
  const reparseRecord = useCallback(async (id, instructions) => {
    try {
      const response = await apInvoicePipelineApi.retryFromStage(id, 'ocr', instructions || undefined);
      if (response.success) {
        message.success('重新解析已触发');
        return true;
      } else {
        message.error('重新解析失败');
        return false;
      }
    } catch (error) {
      message.error('重新解析失败: ' + (error.response?.data?.detail || error.message));
      return false;
    }
  }, []);

  // 创建记录
  const createRecord = useCallback(async (data) => {
    try {
      const response = await api.create(data);
      if (response.data.success) {
        message.success('创建成功');
        return response.data.data;
      } else {
        message.error('创建失败');
        return null;
      }
    } catch (error) {
      message.error('创建失败: ' + (error.response?.data?.detail || error.message));
      return null;
    }
  }, []);

  // 更新记录
  const updateRecord = useCallback(async ({ id, data }) => {
    try {
      const response = await api.update({ id, data });
      if (response.data.success) {
        message.success('更新成功');
        return response.data.data;
      } else {
        message.error('更新失败');
        return null;
      }
    } catch (error) {
      message.error('更新失败: ' + (error.response?.data?.detail || error.message));
      return null;
    }
  }, []);

  return {
    loading,
    fetchList,
    deleteRecord,
    batchDeleteRecords,
    reparseRecord,
    createRecord,
    updateRecord,
  };
};
